
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const HotmartCancelPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="flex flex-col items-center animate-in fade-in zoom-in duration-500">
                    <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-6">
                        <XCircle className="w-10 h-10 text-red-600" />
                    </div>

                    <h1 className="text-2xl font-bold text-gray-900 mb-2">Pago Cancelado</h1>
                    <p className="text-gray-600 mb-8">
                        El proceso de pago fue cancelado o no se pudo completar. No se ha realizado ningún cargo a tu cuenta.
                    </p>

                    <div className="flex flex-col gap-3 w-full">
                        <button
                            onClick={() => navigate('/coins')}
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-xl flex items-center justify-center gap-2 transition-colors"
                        >
                            <RefreshCw size={20} />
                            Intentar nuevamente
                        </button>

                        <button
                            onClick={() => navigate('/dashboard')}
                            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold py-3 px-6 rounded-xl flex items-center justify-center gap-2 transition-colors"
                        >
                            <ArrowLeft size={20} />
                            Volver al Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotmartCancelPage;
